export const SHOW_PARAMS = [ "cost", "revenue", "roi", "winRate", "factor", "lastFactor", "adjustment" ];


// WEBPACK FOOTER //
// ./src/scenes/AdkQuickFactor/config.js